import { IServicePackagePeriod } from '../../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';
import { IServicePeriods } from '../../../../types/reducers/publishTerms';
import { mapPeriod } from '../mapPeriod';

export function mapPeriods(periods: IServicePackagePeriod[]): IServicePeriods {
  return periods.reduce((acc, rawPeriod) => {
    const period = mapPeriod(rawPeriod);

    acc[period.id] = period;

    return acc;
  }, {} as IServicePeriods);
}
